'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$Imported(secret, origin, name, issue, error) {
  this.i7 = null;
  this.tY = null;
  this.oy = null;
  this.iD = null;
  this.KF = null;
  this.i7 = secret;
  this.tY = origin;
  this.oy = name;
  this.iD = issue;
  this.KF = error;
}
export { $c_Lpresto_TwoFactorAuthView$Imported as $c_Lpresto_TwoFactorAuthView$Imported };
$p = $c_Lpresto_TwoFactorAuthView$Imported.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$Imported;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$Imported() {
}
export { $h_Lpresto_TwoFactorAuthView$Imported as $h_Lpresto_TwoFactorAuthView$Imported };
$h_Lpresto_TwoFactorAuthView$Imported.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_TwoFactorAuthView$Imported)) {
    if ((((this.i7 === x$0.i7) && (this.tY === x$0.tY)) && (this.oy === x$0.oy))) {
      var x = this.iD;
      var x$2 = x$0.iD;
      var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.KF;
      var x$4 = x$0.KF;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "Imported";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.i7;
      break;
    }
    case 1: {
      return this.tY;
      break;
    }
    case 2: {
      return this.oy;
      break;
    }
    case 3: {
      return this.iD;
      break;
    }
    case 4: {
      return this.KF;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_TwoFactorAuthView$Imported(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iX)));
}
export { $isArrayOf_Lpresto_TwoFactorAuthView$Imported as $isArrayOf_Lpresto_TwoFactorAuthView$Imported };
var $d_Lpresto_TwoFactorAuthView$Imported = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$Imported, "presto.TwoFactorAuthView$Imported", ({
  iX: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_TwoFactorAuthView$Imported as $d_Lpresto_TwoFactorAuthView$Imported };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Imported.js.map
